import clsx from 'clsx';
import * as R from 'ramda';

import { Checkbox } from '@atom/mui';
import colors from '@atom/styles/colors';
import { FormInstanceFieldItem, PciModuleDistress } from '@atom/types/form';

import classes from './pci.module.css';

interface Props {
  field: FormInstanceFieldItem;
}

const styles = {
  checkbox: {
    marginLeft: '2rem',
  },
  icon: {
    color: colors.neutral.gray,
    marginRight: '0.5rem',
  },
};

const AcSummary = ({ field }: Props) => {
  const hasNoDistress = R.pathOr(false, ['pci', 'hasNoDistress'], field);

  const distresses = R.pathOr<PciModuleDistress[]>(
    [],
    ['pci', 'distress'],
    field,
  );

  return (
    <>
      <div
        className={clsx(
          classes.inspectionContainer,
          hasNoDistress && classes.checked,
        )}
      >
        <div className={classes.noDistressContainer}>
          <div className={classes.subtitle}>Inspection</div>
          <Checkbox
            style={styles.checkbox}
            label="No Distress"
            disabled
            checked={hasNoDistress}
          />
        </div>
      </div>
      {!hasNoDistress && (
        <>
          <div className={classes.tableHeader}>
            <div className={clsx(classes.column, classes.distressSummary)}>
              distress
            </div>
            <div className={clsx(classes.column, classes.severitySummary)}>
              distress severity
            </div>
            <div className={clsx(classes.column, classes.quantitySummary)}>
              total qty
            </div>
          </div>
          <div className={classes.tableRowsContainer}>
            {distresses.map(({ distress, severity, quantity }) => (
              <div className={classes.tableRow}>
                <div
                  className={clsx(
                    classes.column,
                    classes.summary,
                    classes.distressSummary,
                  )}
                >
                  {distress}
                </div>
                <div
                  className={clsx(
                    classes.column,
                    classes.summary,
                    classes.severitySummary,
                  )}
                >
                  {severity}
                </div>
                <div
                  className={clsx(
                    classes.column,
                    classes.summary,
                    classes.quantitySummary,
                  )}
                >
                  {quantity}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default AcSummary;
